import BalanceCom from '@/components/BalanceCom'
import ReturnCom from '@/components/ReturnCom'
import users from '@/image/users.svg'
import img1 from '@/image/img1.svg'
import img2 from '@/image/img2.svg'
import img3 from '@/image/img3.svg'
import img4 from '@/image/img4.svg'
import img5 from '@/image/img5.svg'
import img6 from '@/image/img6.svg'

import useGetUserInfo from '@/web3Hook/useGetUserInfo';
import { SYMBOL } from '@/collocate';
import useGetLinkPerformance from '@/web3Hook/useGetLinkPerformance'
import useGetDayTeamStake from '@/web3Hook/useGetDayTeamStake'
import useGetTeamStake from '@/web3Hook/useGetTeamStake'
import useGetDirectNodeNum from '@/web3Hook/useGetDirectNodeNum'
import useGetValidNodeNum from '@/web3Hook/useGetValidNodeNum'
import ScrollView from '@/components/ScrollView'
import useGetDirectLinkUsers from '@/web3Hook/useGetDirectLinkUsers'
import useAddressConvert from '@/hooks/useAddressConvert'
import { mobileHidden } from '@/utils'
import { useTranslation } from 'react-i18next'

const MyLink = () => {
    const { t } = useTranslation()
    const { userInfo, userInfoLod } = useGetUserInfo();
    const { bestLinkReward,
        smallLinkReward,
        linkPerformanceLod, } = useGetLinkPerformance()
    const { dayTeamStake,
        dayTeamStakeLod, } = useGetDayTeamStake()
    const { teamStake,
        teamStakeLod, } = useGetTeamStake()
    const { directNodeNum,
        directNodeNumLod, } = useGetDirectNodeNum()
    console.log('directNodeNum', directNodeNum);

    const { validNodeNum,
        validNodeNumLod, } = useGetValidNodeNum()
    const { getDirectLinkUsers,
        data,
        loading,
        end } = useGetDirectLinkUsers()
    const { addressConvert } = useAddressConvert()
    return (
        <div className='px-4 mt-3.5 md:px-0'>
            <div className='md:max-w-[900px] md:mx-auto md:mt-6'>
                < ReturnCom title={t('myLink.myLinks')} />
            </div>
            <div className='bg-3f text-bd px-3.5 md:px-6 py-6 md:py-8 rounded-md mt-8 md:mt-6 text-13px md:text-sm mb-5 md:max-w-[900px] md:mx-auto'>
                <div className='flex items-center mb-4 md:mb-6'>
                    <img src={users} className='w-3.5 md:w-4 mr-1.5 md:mr-2' alt="" />
                    <BalanceCom qText={t('myLink.linkAddress') + '：'} balance={userInfo.teamNum} unit={0} loading={userInfoLod} />
                </div>
                <div className='bg-21 rounded-md p-4 md:p-6'>
                    <div className='flex items-center justify-between pb-4 md:pb-5 mb-4 md:mb-5 box-border border-b border-4d'>
                        <div>
                            <div className='flex items-center pb-2.5 md:pb-3'>
                                <img className='mr-1.5 md:mr-2 w-3.5 md:w-4' src={img1} alt="" />
                                <span className='text-xs md:text-sm'>{t('myLink.totalPledge')}</span>
                            </div>
                            <BalanceCom balance={teamStake} loading={teamStakeLod} text={' ' + SYMBOL} />
                        </div>
                        <div>
                            <div className='flex items-center pb-2.5 md:pb-3'>
                                <img className='mr-1.5 md:mr-2 w-3.5 md:w-4' src={img2} alt="" />
                                <span className='text-xs md:text-sm'>{t('myLink.todayNew')}</span>
                            </div>
                            <BalanceCom balance={dayTeamStake} loading={dayTeamStakeLod} text={' ' + SYMBOL} />
                        </div>
                    </div>
                    <div className='flex items-center justify-between'>
                        <div>
                            <div className='flex items-center pb-2.5 md:pb-3'>
                                <img className='mr-1.5 md:mr-2 w-3.5 md:w-4' src={img3} alt="" />
                                <span className='text-xs md:text-sm'>{t('myLink.largeChainTotal')}</span>
                            </div>
                            <BalanceCom balance={bestLinkReward} loading={linkPerformanceLod} text={' ' + SYMBOL} />
                        </div>
                        <div>
                            <div className='flex items-center pb-2.5 md:pb-3'>
                                <img className='mr-1.5 md:mr-2 w-3.5 md:w-4' src={img4} alt="" />
                                <span className='text-xs md:text-sm'>{t('myLink.smallChainTotal')}</span>
                            </div>
                            <BalanceCom balance={smallLinkReward} loading={linkPerformanceLod} text={' ' + SYMBOL} />
                        </div>
                    </div>
                </div>

                <div className='mt-4.5 md:mt-6'>
                    <div className='text-xs md:text-sm mb-3 md:mb-4'>{t('myLink.myAddress')}</div>
                    <div className='bg-21 rounded-md p-4 md:p-6'>
                        <div className='flex items-center justify-between'>
                            <div>
                                <div className='flex items-center pb-2.5 md:pb-3'>
                                    <img className='mr-1.5 md:mr-2 w-3.5 md:w-4' src={img5} alt="" />
                                    <span className='text-xs md:text-sm'>{t('myLink.addressCount')}</span>
                                </div>
                                <BalanceCom balance={directNodeNum} unit={0} loading={directNodeNumLod} text={''} />
                            </div>
                            <div>
                                <div className='flex items-center pb-2.5 md:pb-3'>
                                    <img className='mr-1.5 md:mr-2 w-3.5 md:w-4' src={img6} alt="" />
                                    <span className='text-xs md:text-sm'>{t('myLink.validAddress')}</span>
                                </div>
                                <BalanceCom balance={validNodeNum} unit={0} loading={validNodeNumLod} text={''} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='border border-4d text-xs md:text-sm rounded-lg mt-4.5 md:mt-6 overflow-hidden'>
                    <div className='bg-21 h-10.5 md:h-12 flex items-center justify-between px-3.75 md:px-5 text-ad'>
                        <span className='w-[40%]'>{t('myLink.address')}</span>
                        <span className='w-[30%] text-center'>{t('myLink.currentPledgeAmount')}</span>
                        <span className='w-[30%] text-right'>{t('myLink.currentHashratePool')}</span>
                    </div>
                    <ScrollView className='px-3.75 md:px-5' px={'30rem'} scroll={{ onScroll: getDirectLinkUsers, isOver: end, loading: loading }} >
                        {
                            data.userL0Addr.map((item, index) => {
                                return <div key={index} className='text-white flex items-center justify-between py-3 md:py-4'>
                                    <div className='w-[40%] text-xs md:text-sm'>{mobileHidden(addressConvert(data.userL0Addr[index]))}</div>
                                    <BalanceCom className='w-[30%] text-center text-xs md:text-sm' balance={data.amount[index]} text={SYMBOL} decimals={0} loading={false} />
                                    <BalanceCom className='w-[30%] text-right text-xs md:text-sm' balance={data.poolBalance[index]} text={SYMBOL} decimals={0} loading={false} />
                                </div>
                            })
                        }
                    </ScrollView>
                </div>
            </div>
        </div>
    )
}

export default MyLink